import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const updateUser = async (options, otherUserId = undefined) => {
  const { token, userID } = useCurrentUser();
  const apiURL = API_HOST + '/users/' + (otherUserId ?? userID);
  
  try {
    const { data } = await axios.patch(apiURL, {user: {...options}},{
      headers: {
      'Content-Type': 'application/json',
        'Authorization': 'Bearer '+token,
        'x-sb-user-id': userID
    }
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
